import store from '@/store'
import { orderStatusHistory } from '@/config'
import { commonUtil, supplierUtil } from '@/util'

export default {
  getOrderById(orderId) {
    const orderList = store.getters['Order/getOrderListFromState']
    return orderList.find((v) => v.orderId === orderId)
  },
  // 発注データの合計金額の算出
  calcOrderAmountById(orderId) {
    const order = this.getOrderById(orderId)
    let totalTmp = order.productMoves.reduce((sum, ele) => {
      return sum + ele.quantity * (ele.price * 100)
    }, 0)

    return (
      (totalTmp +
        Number(order.consumptionTax8) * 100 +
        Number(order.consumptionTax10) * 100 +
        Number(order.comission) * 100 -
        Number(order.discount) * 100) /
      100
    )
  },
  getOrderWithdrawStatusList() {
    return commonUtil.getStatusHistoryIdNameList(
      orderStatusHistory.WITHDRAW_STATUS,
      orderStatusHistory.STATUS_HISTORY_LABEL
    )
  },
  getOrderLoadingStatusList() {
    return commonUtil.getStatusHistoryIdNameList(
      orderStatusHistory.LOADING_STATUS,
      orderStatusHistory.STATUS_HISTORY_LABEL
    )
  },
  getOrderCompleteStatusList() {
    return commonUtil.getStatusHistoryIdNameList(
      orderStatusHistory.COMPLETE_STATUS,
      orderStatusHistory.STATUS_HISTORY_LABEL
    )
  },
  getOrderRegisterStatusList() {
    return commonUtil.getStatusHistoryIdNameList(
      orderStatusHistory.REGISTER_STATUS,
      orderStatusHistory.STATUS_HISTORY_LABEL
    )
  },
  getStatusListByType(type) {
    switch (type) {
      case orderStatusHistory.STATUS_HISTORY_TYPE_ID.WITHDRAW:
        return this.getOrderWithdrawStatusList()
      case orderStatusHistory.STATUS_HISTORY_TYPE_ID.LOADING:
        return this.getOrderLoadingStatusList()
      case orderStatusHistory.STATUS_HISTORY_TYPE_ID.COMPLETE:
        return this.getOrderCompleteStatusList()
    }
  },
  getStatusHistoryTypeList() {
    const ret = []
    for (let key in orderStatusHistory.STATUS_HISTORY_TYPE_ID) {
      ret.push({
        id: orderStatusHistory.STATUS_HISTORY_TYPE_ID[key],
        name: orderStatusHistory.STATUS_HISTORY_TYPE_LABEL[key]
      })
    }
    return ret
  },
  getSupplierDisplayName(order) {
    return supplierUtil.getSupplierDisplayName(order.supplier)
  }
}
